import { mapGetters } from 'vuex'

export default {
  props: {
    file: [Object, File],
    userCanAddAttachment: Boolean,
    userCanRemoveAttachment: Boolean,
    userCanPreviewAttachment: Boolean
  },
  computed: {
    ...mapGetters({
      loaders: 'loaderStore/loading'
    }),

    name () {
      return this.file.filename
    },
    size () {
      return this.formatBytes(this.file.contentSize, 1)
    },
    loading () {
      return this.loaders['attachments-progress'] === this.file.id
    },
    deleting () {
      return this.loaders['delete-attachment'] === this.file.id
    },
    downloading () {
      return this.loaders['download-attachment'] === this.file.id
    }
  },
  methods: {
    fileClicked () {
      if (this.deleting || this.loading) return
      return this.$emit('click')
    },
    formatBytes (bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    deleteFile () {
      return this.$emit('delete')
    },
    openFile () {
      if (this.deleting || this.loading) return
      return this.$emit('clickView')
    }
  }
}
